import React, { Fragment } from "react";
import i18next from "i18next";
import ReactPlayer from "react-player";
import { withTranslation, Trans } from "react-i18next";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import Select from "@material-ui/core/Select";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import classnames from "classnames";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import Services from "../../api/api";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setLangID } from "../../redux/actions/appActions";
import DependentQuestionnaire from "./DependentQuestionnaire";

const useStyles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "-webkit-fill-available",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    backgroundColor: "rgba(0, 0, 0, .02)",
  },
});

let dependantquestionArr= [];

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionlist: [],
      dependantquestionlist: [],
      dependantquestionArr: [],
      isLoading: false,
      showSlider: true,
      temp: false,
      isPlay: false,
      animCssClasses: "animate__animated animate__zoomIn animate__faster",
    };

    
  }

  componentDidMount() { }

  static getDerivedStateFromProps(nextProps) {
    return {
      animCssClasses: nextProps.animCssClasses,
      showSlider: nextProps.showSlider,
    };
  }

  callsameCompomnet = () => {
    const { classes } = this.props;
    var element = this.props.question;
    if (element.dependentQuestionResponse != null && element.dependentQuestionResponse.length > 0) {
      return element.dependentQuestionResponse.map((Obj, index) => {
        return (
          <Questionnaire
            key={index}
            question={Obj}
            classes={classes}
            componentbgcolor={this.props.componentbgcolor}
          />
        );
      });
    }
    //return null;
  };

  renderQuestion() {
    const { classes } = this.props;
    var element = this.props.question;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { color: this.props.componentbgcolor } : {};
    let bgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    var quslist = [];
    return (
      <>
        {
          templateID == 1 ? (
            <Card className="infocard">
              <CardContent className="pt-0px pb-0px">
                <Grid container spacing={3} className="gridcontainer border-bottom-grey">
                  <Grid item xs={2} className="text-center hospitaliconholder color-purple">
                    <LocalHospitalIcon />
                  </Grid>
                  <Grid item xs={10} className="text-left">
                    <p className="hospitalinfo">{element.question}</p>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="gridcontainer">

                  <Grid item xs={12} className="text-left reportdetailedtextholder">
                    <div className="reportform">
                      <FormControl component="fieldset" className={classes.formControl}>
                        <FormGroup>{this.getQuestionType(element)}</FormGroup>
                      </FormControl>
                      {
                        this.callsameCompomnet()
                      }
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="gridcontainer border-top-grey">
                  <Grid item xs={12} className="text-left color-purple">
                    {element.responseExtension && element.responseExtension.imageURLs.length > 0 &&
                      (<img
                        src={element.responseExtension.imageURLs[0]}
                        width={"100%"}
                        height={200}
                        light={true}
                        style={{ marginTop: "0px" }}
                      />)
                    }
                    {
                      element.responseExtension && element.responseExtension.videoURLs.length > 0 &&
                      (<ReactPlayer
                        url={element.responseExtension.videoURLs[0]}
                        width={"100%"}
                        height={200}

                        style={{ marginTop: "0px" }}
                        playing={this.state.isPlay}
                        onPlay={() => this.onPlay()}
                        onPause={() => this.onPause()}
                        controls={true}
                      />)
                    }
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ) :
            (
              <>
                <Grid
                  key={element.id}
                  container
                  spacing={0}
                  className="gridcontainer chatuserlistdiv"
                >
                  <Grid item xs={2} className="zero">
                    <p className="zero  text-center forumicon">
                      <LockOpenIcon style={bgStyles} />
                    </p>
                  </Grid>
                  <Grid item xs={10} className="zero">
                    <p className="zero  chatusername" style={colorStyles}>{element.question}</p>
                  </Grid>
                </Grid>
                <div className={classes.root}>
                  <div className="reportform">
                    <FormControl component="fieldset" className={classes.formControl}>
                      <FormGroup>{this.getQuestionType(element)}</FormGroup>
                      {
                        this.callsameCompomnet()
                      }
                    </FormControl>
                  </div>
                </div>
                <div className="evidancePreview">
                  {element.responseExtension && element.responseExtension.imageURLs.length > 0 &&
                    (<img
                      src={element.responseExtension.imageURLs[0]}
                      width={"100%"}
                      height={200}
                      light={true}
                      style={{ marginTop: "0px" }}
                    />)
                  }
                  {
                    element.responseExtension && element.responseExtension.videoURLs.length > 0 &&
                    (<ReactPlayer
                      url={element.responseExtension.videoURLs[0]}
                      width={"100%"}
                      height={200}

                      style={{ marginTop: "0px" }}
                      playing={this.state.isPlay}
                      onPlay={() => this.onPlay()}
                      onPause={() => this.onPause()}
                      controls={true}
                    />)
                  }
                </div>
              </>
            )
        }
      </>
    );
  }

  onPlay() {
    this.setState({isPlay: true})
  }

  onPause() {
    this.setState({isPlay: false})
  }


  getQuestionType(element) {
    switch (element.type.toLowerCase()) {
      case "text":
        return this.getTextType(element);
        case "number":
          return this.getTextType(element);
      case "date":
        return this.getDateType(element);
      case "radio":
        return this.getRadioType(element);
        case "dropdown":
          return this.getRadioType(element);
      case "checkbox":
        return this.getCheckboxType(element);
    }
  }



  getTextType(element) {
    let val = element["response"]["value"][0]
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={"text-" + element.id}
        value={val}
        control={
          <TextField  value={val} name={'text-' + element.id} disabled={true} />
        }
      />
    );
  }

  getDateType(element) {
    let val = element["response"]["value"][0]
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={"text-" + element.id}
        value={val}
        control={
          <TextField  value={val} type="date" name={'date-' + element.id} disabled={true} />
        }
      />
    );
  }

  getRadioType(element) {
    var radiobuttons = [];
    let options = Object.keys(element.optionMap);
    options.map((o, i) => {
      radiobuttons.push(
        <FormControlLabel
          key={i}
          id={i}
          name={"radio-" + element.id}
          value={o}
          control={<Radio name={"radio-" + element.id} />}
          label={element.optionMap[o]}
          
        />
      );
    });

    let val = element["response"]["value"][0]

    return <RadioGroup name={element.name} value={val}>{radiobuttons}</RadioGroup>;
  }

  getCheckboxType(element) {
    var checkbuttons = [];
    let keys = Object.keys(element.optionMap);
    keys.map((o, i) => {
      checkbuttons.push(
        <FormControlLabel
          key={i}
          name={"check-" + element.id}
          value={o}
          control={<Checkbox name={"checkbox-" + element.id} />}
          label={element.optionMap[o]}
          
        />
      );
    });
    return <FormGroup>{checkbuttons}</FormGroup>;
  }


  getDepenedantquestion (element){
    const { classes } = this.props;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { color: this.props.componentbgcolor } : {};
    let cbgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    var quslist = [];
    return (
      <>
        <Grid
          key={element.id}
          container
          spacing={0}
          className="gridcontainer chatuserlistdiv"
        >
          <Grid item xs={2} className="zero">
            <p className="zero  text-center forumicon">
              <LockOpenIcon style={cbgStyles} />
            </p>
          </Grid>
          <Grid item xs={10} className="zero">
            <p className="zero  chatusername" style={colorStyles}>{element.question}</p>
          </Grid>
        </Grid>
        <div className={classes.root}>
          <div className="reportform">
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>{this.getQuestionType(element)}</FormGroup>
            </FormControl>
          </div>
        </div>
      </>
    );
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;

    if (this.props.question) {
      return <>{this.renderQuestion()}</>;
    }
    return null;
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

let newQuestionnaire = withStyles(useStyles)(withTranslation()(Questionnaire));
export default connect(mapStateToProps, {})(newQuestionnaire);

